import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Civil } from "./civil";
import { Address } from "./address";
import { Family } from "./family";
import { FamilyEnvironment } from "./familyEnv";
import { SituationPro } from "./situationPro";
import { Activity } from "./activity";
import { OtherActivity } from "./otherActivity";
import { Retraite } from "./retraite";
import { EducationInstitution } from "./educationInstitution";
import * as loadings from "../../../../../../constants/loadings/relocationDeclaration";
import { updateDeathDeclaration, getUserServiceData } from "../../../../../../actions/facilita-api";
import { updateRelocationDeclaration } from "../../../../../../actions/events-api";
import { ProfessionOptions, FrenchTypes } from "../../../../../../constants/utils/connectionTypes";

export const Step2 = ({ userId, relocationDeclaration, isLoading, serviceDatas, setOnboardingStep, getDeclaration }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const formRef = useRef();
	useEffect(() => {
		dispatch(getUserServiceData(userId));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<article className="view-calc pt-3 mb-auto">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-5">
					<h1 className="text-primary font-weight-bolder mt-2 mb-3">Valider vos informations</h1>
				</header>
			</div>
			<div className="auto-view scroll-auto py-2 pb-lg-0">
				<div className="container-fluid">
					<form noValidate ref={formRef}>
						<Civil relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} />
						<Address relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} type={"oldAddress"} />
						<Family relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} />
						{relocationDeclaration?.hasChildren && <FamilyEnvironment relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} />}

						<SituationPro relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} getDeclaration={getDeclaration} />
						{relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.active) && <Activity activities={serviceDatas?.filter((s) => s.serviceType === FrenchTypes.activity)} isLoading={isLoading} userId={userId} relocationDeclaration={relocationDeclaration} />}
						{relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.retired) && <Retraite pensions={serviceDatas?.filter((s) => s.serviceType === FrenchTypes.pension)} isLoading={isLoading} userId={userId} relocationDeclaration={relocationDeclaration} />}
						{relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.other) && <OtherActivity activities={serviceDatas?.filter((s) => s.serviceType === FrenchTypes.otherActivity)} isLoading={isLoading} userId={userId} relocationDeclaration={relocationDeclaration} />}
						{relocationDeclaration?.professionalSituation?.includes(ProfessionOptions.student) && <EducationInstitution educationInstitutions={serviceDatas?.filter((s) => s.serviceType === FrenchTypes.etudiant)} isLoading={isLoading} userId={userId} relocationDeclaration={relocationDeclaration} />}

						<Address relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} type={"newAddress"} />
					</form>
				</div>

				<div className="container-fluid mt-3">
					<footer className="d-block mt-auto mb-sm text-right w-100">
						<button
							className="btn btn-faded px-md-gutter mr-3"
							onClick={() => {
								setOnboardingStep(1);
							}}>
							Retour
						</button>
						{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
							<button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">
								Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info loading-btn px-md-gutter px-4"
								onClick={async (event) => {
									event.preventDefault();
									if (formRef.current.checkValidity()) {
										dispatch(updateRelocationDeclaration(userId, { ...relocationDeclaration, onBoardingStep: 3 })).then(() => {
											getDeclaration();
											setOnboardingStep(3);
										});
									}
									formRef.current.classList.add("was-validated");
								}}>
								Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						)}
					</footer>
				</div>
			</div>
		</article>
	);
};
